<template>
    <div id="top" :class="{'block-invert block-img': content.settings[0].homeimagealign == 'imgbg'}" :style="[content.settings[0].homeimagealign == 'imgbg' ? {'background-image': 'url(' + homeimage + ')'} : {}]" >
        <div class="section-block center-items" :class="'text-'+content.settings[0].heroalign">
            <div class="container">
                <div id="hero_unit">
                    <div v-if="!createsite">
                      <h1 class="display-3 mb-3 mt-5">{{ content.tagline }} </h1>
                      <p class="mb-5 display-6 text-muted">
                        <span class="edited_content">
                          {{ content.description }} 
                        </span>
                      </p>
                      <div>
                        <h2 class="display-6 mt-5 mb-3"><span class="number-bullet">1</span> Kies een thema</h2>
                        <div id="themethumbs">
                          <ul class="thumb-selector">
                            <li><input type="radio" v-model="selectedtheme" value="default" id="themedefault" /> <label @click="scrollToElement();" for="themedefault" style="background-image: url('/theme-default.jpg')"><span>Makers</span></label></li>
                            <li><input type="radio" v-model="selectedtheme" value="white" id="themewhite" /> <label @click="scrollToElement();" for="themewhite" style="background-image: url('/theme-white.jpg')"><span>Minimaal</span></label></li>
                            <li><input type="radio" v-model="selectedtheme" value="business" id="themebusiness" /> <label @click="scrollToElement();" for="themebusiness" style="background-image: url('/theme-business.jpg')"><span>Zakelijk</span></label></li>
                            <li><input type="radio" v-model="selectedtheme" value="influencer" id="themeinfluencer" /> <label @click="scrollToElement();" for="themeinfluencer" style="background-image: url('/theme-influencer.jpg')"><span>Influencer</span></label></li>
                            <!--li><input type="radio" v-model="selectedtheme" value="product" id="themeproduct" /> <label @click="scrollToElement();" for="themeproduct" style="background-image: url('/theme-product.jpg')"><span>Product</span></label></li-->
                            <li><input type="radio" v-model="selectedtheme" value="technology" id="themetechnology" /> <label @click="scrollToElement();" for="themetechnology" style="background-image: url('/theme-technology.jpg')"><span>Technologie</span></label></li>
                          </ul>
                        </div>
                      </div>
                      <div id="entermail">
                        <h2 class="display-6 mt-5 mb-4"><span class="number-bullet">2</span> Begin meteen</h2>
                        <transition name="fade">
                          <div class="alert mw-650px mr-auto ml-auto" v-if="msgtext" :class="msgclass" v-html="msgtext"></div>
                        </transition>
                        <form @submit.prevent="createSite" id="create-site">
                          <input type="email" ref="email" @input="msgtext = ''" placeholder="Jouw e-mail..." name="user-email" v-model="username" class="form-control form-control-lg mr-4">
                          <button name="submit-create-site" :disabled="loading" class="btn btn-lg btn-primary">
                            <loader v-if="loading" style="margin-bottom: -10px;"/><span v-if="!loading" >Maak site aan</span>
                          </button>
                        </form>
                        <!--div class="mt-3 text-muted">Wanneer je een website aanmaakt ga je akkoord met de <a href="#">Algemene Voorwaarden</a></div-->
                      </div>
                    </div>
                  <transition name="fade">
                    <div v-if="createsite">
                      <h1 class="display-5 mb-3 mt-5">Jouw website word nu aangemaakt</h1>
                      <p class="mb-4 display-6"><span class="edited_content">Wanneer je de volgende keer terug wil komen, klik dan op 'Inloggen' hierboven.</span></p>
                      <div v-if="!siteready">
                        <loader style="zoom: .9;"/>
                      </div>
                      <transition name="fade">
                        <a v-if="siteready" class="btn btn-lg btn-gradient-primary" :href="'/creator/'+createdwebsiteid">Bekijk jouw website</a>
                      </transition>
                    </div>
                  </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import MainFooter from '../components/navigation/MainFooter.vue';
  import SectionBlock from '../components/content/SectionBlock.vue';
  import PageAdder from '../components/app/PageAdder.vue';
  
  import axios from 'axios';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';

  export default {
    props:{
      content: {
        type: Object
      },
      homeimage: {
          type: String
      }
    },
    data: function (){
      return {
        readonly: false,
        createsite: false,
        siteready: false,
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        error: '',
        pages: {},
        websiteid: process.env.VUE_APP_ROOT_ID,
        phabsiteid: '9t6tmaV5vz9f1Su',
        selectedtheme: 'default',
        mainpageid: 'home',
        createdwebsiteid: ''
      }
    },
    created () {
      // reset login status
      userService.logout();

      // get return url from route parameters or default to '/'
      this.returnUrl = this.$route.query.returnUrl || '/';
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      MainNav,
      PageAdder,
      MainFooter,
      SectionBlock
    },
    methods: {
      scrollToElement(){
        this.$scrollTo('#entermail', 500, {container: "body", easing: "ease-in", offset: -160 })
        setTimeout(function () { this.$refs.email.focus();  }.bind(this), 800)
      },
      createSite(){

          if(!this.username){
            this.msgtext = 'Geef een emailadres op om een mooie site te beginnen.'
            this.loading = false
            return
          }
          const data = {
            email: this.username,
            settings: [{
              theme: this.selectedtheme
            }]
          }

          this.loading = true

          axios.post(process.env.VUE_APP_ROOT_API+'/users/', data)
          .then(
            response => {
              localStorage.setItem('user', JSON.stringify(response.data));
              this.createdwebsiteid = response.data.websiteid
              //window.location.href = '/creator/'+response.data.websiteid
              this.$scrollTo('#top', 500, {container: "body", easing: "ease-in" })

              this.createsite = true;
              //setTimeout(function(){ this.siteready = true }, 3000);
              var t = this;
              setTimeout(function () {
                  t.siteready = true;
              }, 3000);
            },
            error => {
              this.loading = false
              this.msgtext = 'Dit emailadres is al in gebruik. Je kunt ook <a href="/login">inloggen</a> met dit emailadres.'
            }
          )
      }
    },
    mounted(){
    }
  }
</script>
